module.exports = __webpack_public_path__ + "static/media/promo-portal.cb807b78.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/portfolio/promo-portal.jpg
// module id = 314
// module chunks = 0